import { useEffect, useState } from 'react';
import axios from 'axios';

export default function ConversationsDashboardStats() {
  const [totalConversations, setTotalConversations] = useState(0);
  const [progresses, setProgresses] = useState([]);
  const [activeUsers, setActiveUsers] = useState(0);
  const [messagesLast24h, setMessagesLast24h] = useState(0);

  useEffect(() => {
    axios.get('/api/conversations', { withCredentials: true })
      .then(response => setTotalConversations((response.data || []).length))
      .catch(() => {});
    axios.get('/api/conversationprogress', { withCredentials: true })
      .then(response => setProgresses(response.data || []))
      .catch(() => {});
    axios.get('/api/chats', { withCredentials: true })
      .then(response => setActiveUsers((response.data || []).length))
      .catch(() => {});
    axios.get('/api/messages/last-activity', { withCredentials: true })
      .then(response => {
        const total = (response.data || []).reduce((sum, part) => sum + (part.amount || 0), 0);
        setMessagesLast24h(total);
      })
      .catch(() => {});
  }, []);

  const finishedCount = progresses.filter(p => p.isFinished === 1).length;
  const completionRate = progresses.length > 0 ? Math.round((finishedCount / progresses.length) * 100) : 0;

  const tiles = [
    { value: totalConversations, label: 'Шаблонів розмов' },
    { value: progresses.length, label: 'Проходжень всього' },
    { value: completionRate + '%', label: 'Завершеність' },
    { value: activeUsers, label: 'Telegram користувачів' },
    { value: messagesLast24h, label: 'Повідомлень за 24г' },
  ];

  return (
    <div className="conv-progress-stats-row">
      <div className="conv-progress-stats">
        {tiles.map((tile, index) => (
          <div className="conv-progress-stat" key={index}>
            <span className="conv-progress-stat-value">{tile.value}</span>
            <span className="conv-progress-stat-label">{tile.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
